import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t" style={{ backgroundColor: '#1a1411', borderColor: '#2a1f1a' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="text-center sm:text-left">
            <div className="flex justify-center sm:justify-start mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_guelph-electric/artifacts/8iae4xfm_IMG_1075.jpeg"
                alt="Janes Electrical Services"
                className="h-16 sm:h-20 w-auto"
              />
            </div>
            <p className="leading-relaxed text-sm sm:text-base" style={{ color: '#9c7c5e', fontFamily: "'Rajdhani', sans-serif" }}>
              Locally owned and operated electrical contracting company serving 
              Guelph and the Greater Golden Horseshoe region.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6 tracking-wide" style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}>QUICK LINKS</h4>
            <nav className="space-y-2 sm:space-y-3">
              {['services', 'areas', 'contact'].map((section) => (
                <button 
                  key={section}
                  onClick={() => scrollToSection(section)} 
                  className="block w-full sm:w-auto transition-all duration-200 hover:translate-x-1 uppercase text-sm sm:text-base tracking-wide"
                  style={{ color: '#9c7c5e', fontFamily: "'Rajdhani', sans-serif" }}
                  onMouseEnter={(e) => e.target.style.color = '#d4c19c'}
                  onMouseLeave={(e) => e.target.style.color = '#9c7c5e'}
                >
                  {section === 'areas' ? 'Service Areas' : section}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left">
            <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6 tracking-wide" style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}>CONTACT US</h4>
            <a 
              href={`mailto:${companyInfo.email}`}
              className="flex items-center gap-2 sm:gap-3 transition-colors duration-200 mb-3 sm:mb-4 hover:opacity-80 justify-center sm:justify-start"
              style={{ color: '#d4c19c' }}
            >
              <Mail className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
              <span className="text-sm sm:text-base break-all" style={{ fontFamily: "'Rajdhani', sans-serif" }}>{companyInfo.email}</span>
            </a>
            <div className="flex items-center gap-2 sm:gap-3 justify-center sm:justify-start" style={{ color: '#9c7c5e' }}>
              <MapPin className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
              <span className="text-sm sm:text-base" style={{ fontFamily: "'Rajdhani', sans-serif" }}>Guelph, Ontario, Canada</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t mt-8 sm:mt-12 pt-6 sm:pt-8" style={{ borderColor: '#2a1f1a' }}>
          <p className="text-center text-sm mb-2 tracking-wide" style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}>
            Licensed Electrical Contractor - ECRA/ESA #7018672
          </p>
          <p className="text-center text-xs sm:text-sm" style={{ color: '#5c4a3d', fontFamily: "'Rajdhani', sans-serif" }}>
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
